import { render, staticRenderFns } from "./vsm_mobile_cards.vue?vue&type=template&id=2bf5dfa7&scoped=true&"
import script from "./vsm_mobile_cards.vue?vue&type=script&lang=js&"
export * from "./vsm_mobile_cards.vue?vue&type=script&lang=js&"
import style0 from "./vsm_mobile_cards.vue?vue&type=style&index=0&id=2bf5dfa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf5dfa7",
  null
  
)

export default component.exports